export default __webpack_public_path__ + "static/p3-0acbd9e84ec53a3ea873818bcf33762a.png";